import type { ContractType } from '../../types/agreement'
import { getUnitTypeOptions } from '../../lib/unitTypeHelpers'

interface LineItemUnitTypeSelectProps {
  value: string
  contractType: ContractType
  includeRateCardTypes?: boolean
  onChange: (value: string) => void
  className?: string
}

export function LineItemUnitTypeSelect({
  value,
  contractType,
  includeRateCardTypes = true,
  onChange,
  className = 'w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
}: LineItemUnitTypeSelectProps) {
  const options = getUnitTypeOptions(contractType, { includeRateCardTypes })

  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className={className}>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  )
}
